// Robust scroll reveal: content starts slightly lowered + transparent and
// animates to full opacity ONCE when it enters the viewport (useInView,
// once:true). It always finishes at opacity 1 / y 0, so nothing can get
// stuck dimmed. Triggers a little before fully on-screen for a cinematic feel.
import { useRef } from "react";
import { motion, useInView } from "framer-motion";

export const ScrollReveal = ({
  children,
  className = "",
  delay = 0,
  y = 22,
  duration = 0.7,
  as = "div",
}) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "0px 0px -8% 0px" });
  const M = motion[as] || motion.div;
  return (
    <M
      ref={ref}
      initial={{ opacity: 0, y }}
      animate={inView ? { opacity: 1, y: 0 } : undefined}
      transition={{ duration, delay, ease: [0.22, 1, 0.36, 1] }}
      className={className}
    >
      {children}
    </M>
  );
};
